import React, { useState } from "react";
import BaseModal from "../Common/BaseModal";

const BeneficiaryModal = ({ show, onClose, onSave, initialData }) => {
  const fields = [
    { name: "id", label: "id", type: "hidden", placeholder: "id" },
    { name: "name", label: "이름", type: "text", placeholder: "이름 입력" },
    { name: "birth_date", label: "생년월일", type: "date", placeholder: "생년월일 입력" },
    { name: "gender", label: "성별", type: "text", placeholder: "성별 입력" },
    { name: "phone_num_1st", label: "전화번호", type: "text", placeholder: "연락처 입력" },
  ];

  return (
    <BaseModal
      title="수급자 정보"
      show={show}
      onClose={onClose}
      onSave={onSave}
      fields={fields}
      initialData={initialData}
    />
  );
};

export default BeneficiaryModal;
